export const generateFullRegionName = function(str) {
    if (!str) {
        return null;
    }
    if (str.includes("kommun")) { 
        return str;
    }
    let x = str.slice(-1);
    if (x == 'a' || x == 'e' || x == 'i' || x == 'o' || x == 'u' || x == 'ä' || x == 'å' || x == 'ö' || x == 'x' ||  x == 's' || x == 'y') {
        str = str.concat(" kommun"); // possessive word ending with vowel or 'x' or 's' will not end with s
    } else {
        str = str.concat("s kommun"); // possessive word ends with s 
    }
    return str;
}


// WEBPACK FOOTER //
// ./src/helpers/region-suffix.js